import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  deleteKey,
  fetchKeys,
  type KeysOut,
  type Provider,
  setKey,
  validateKeys,
} from "./api";

export const KEYS_QK = ["me", "keys"] as const;

export function useKeysQuery() {
  return useQuery<KeysOut>({
    queryKey: KEYS_QK,
    queryFn: fetchKeys,
    staleTime: 30_000,
  });
}

export function useSetKey(provider: Provider) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => setKey(provider, key),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS_QK }),
  });
}

export function useDeleteKey(provider: Provider) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => deleteKey(provider),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS_QK }),
  });
}

export function useValidateKeys() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: validateKeys,
    onSuccess: (data) => qc.setQueryData(KEYS_QK, data),
  });
}
